import { ElementRef, Renderer2 } from '@angular/core';
var ImageLoadDirective = /** @class */ (function () {
    function ImageLoadDirective(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.renderer.setStyle(this.elementRef.nativeElement, 'opacity', 0);
        this.renderer.setStyle(this.elementRef.nativeElement, 'transition', 'opacity 300ms ease-in-out');
    }
    ImageLoadDirective.prototype.onLoad = function () {
        this.renderer.setStyle(this.elementRef.nativeElement, 'opacity', 1);
    };
    return ImageLoadDirective;
}());
export { ImageLoadDirective };
